import React from "react";
import { connect } from "react-redux";

import { getClubTopUpDefaultAmount, getStudentSchoolID } from "state/school_money/selectors";
import { addCreditTopUpToBasket } from "state/school_money/actions";

import CreditTopUp from "components/school_money/CreditTopUp";

class ClubCreditTopUp extends React.Component {
  
  addToBasket = amount => {
    const { studentID } = this.props;
    this.props.addToBasket("club_extended_services", studentID, amount);
  }
  
  render() {
    const { defaultAmount } = this.props;
    return (
      <CreditTopUp
        label="Club Top Up"
        defaultAmount={defaultAmount}
        onAddToBasket={this.addToBasket}
      />
    )
  }
  
}

export default connect(
  (state, { studentID }) => {
    const schoolID = getStudentSchoolID(state, studentID);
    return {
      schoolID,
      defaultAmount: getClubTopUpDefaultAmount(state, schoolID)
    }
  },
  {
    addToBasket: addCreditTopUpToBasket
  }
)(ClubCreditTopUp);



// WEBPACK FOOTER //
// ./src/components/school_money/clubs/ClubCreditTopUp.js